/* eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import { LayerGroup, LeafletEvent, Marker, DivIcon, markerClusterGroup, marker } from 'leaflet';
import 'leaflet.markercluster';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { IModalData } from '@/services/layers/IModalData';
import AssetIconService from '@/services/AssetIconService';
import ApiService from '@/services/ApiService';
import { AxiosResponse } from 'axios';
import IPosition from '@/interfaces/IPosition';
import IFeature from '@/interfaces/IFeature';
import { toRaw } from 'vue';
import MapIconsGeneratorService from '../MapIconsGeneratorService';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';

export default class VmsBoardsLayerService extends LayerService {
  // eslint-disable-next-line global-require
  onClick = async (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): Promise<void> => {
    const title = metaData.name || this.noData;
    let modalIconUrl: string = AssetIconService.getSvgModalIcon('modal_vms_board');

    const modalData: IModalData = {
      title: title,
      content: '',
      navigationPoint: undefined,
      lastUpdate: '',
      icon: modalIconUrl,
      templateName: 'TemplateModalVmsBoard',
      metaData: metaData,
      iconClassName: '',
    };
    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.vmsBoards;
    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      markerClusterGroupInstance.addLayer(toRaw(singleMarker));
    });

    return markerClusterGroupInstance;
  };

  public createMarker = (position: IPosition, feature: IFeature): Marker => {
    const singleMarker = marker([position.lat, position.lng], {
      icon: new DivIcon({
        html: this.generateHtmlPointTemplate(feature.properties),
        iconSize: [this.markerWidth, this.markerHeight],
        iconAnchor: [this.markerWidth / 2, this.markerHeight],
      }),
      draggable: false,
    });

    singleMarker.on('click', (e) => {
      this.onClick(e, feature.properties, singleMarker);
    });

    return singleMarker;
  };

  generateClusterHtml(population: number) {
    const settings: IClusterIconSettings = {
      className: 'g__color--vms',
      insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_vms.svg`),
      population,
    };
    const iconHtml = MapIconsGeneratorService.getClusterIcon(settings);
    
    return iconHtml;
  }

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const settings: IMarkerIconSettings = {
      className: 'g__color--vms',
      insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_vms.svg`),
    };
    const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);

    return iconHtml;
  };
}
